module.exports = __webpack_public_path__ + "static/img/picture6.8f565cec.png";